import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, onConsentOpen, loadTracking } from "@/lib/consent";

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!getConsent()) setOpen(true); else loadTracking();
    return onConsentOpen(() => setOpen(true));
  }, []);

  if (!open) return null;
  const choose = (v) => { setConsent(v); setOpen(false); };

  return (
    <div role="dialog" aria-label="Preferenze cookie" data-testid="cookie-banner"
         className="fixed inset-x-0 bottom-0 z-[60] border-t border-bronze/40 bg-warm/95 backdrop-blur-md shadow-[0_-8px_30px_rgba(31,61,43,0.12)]">
      <div className="container-ph py-5 flex flex-col lg:flex-row lg:items-center gap-5">
        <p className="text-sm text-ink/80 leading-relaxed flex-1">
          Questo sito utilizza cookie tecnici necessari al funzionamento e, solo con il tuo consenso, cookie di analisi e marketing
          (Google Analytics, Meta Pixel) per misurare le visite e migliorare la comunicazione. Puoi modificare la scelta in qualsiasi momento.{" "}
          <Link to="/cookie" className="underline underline-offset-2 text-forest hover:text-bronze" data-testid="cookie-banner-policy-link">Cookie Policy</Link>
        </p>
        <div className="flex flex-col sm:flex-row gap-3 lg:pr-20">
          <button onClick={() => choose("necessary")} className="btn-outline !py-2.5 !px-5" data-testid="cookie-necessary-button">Solo necessari</button>
          <button onClick={() => choose("all")} className="btn-primary !py-2.5 !px-5" data-testid="cookie-accept-all-button">Accetta tutti</button>
        </div>
      </div>
    </div>
  );
};
